import axios from '@/libs/api.request'

export const login = ({ userName, password }) => {
  const data = {
    userName,
    password
  }
  return axios.request({
    url: '/usercenter/sso/login',
    data,
    noToken:true,
    method: 'post'
  })
}

export const getUserInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/user/' + id
  })
}

export const getUserAccountInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/user/account/' + id
  })
}

export const getUserPayCoinsList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/user/pay/coins'
  })
}

export const getUserPayWalletList = (id) => {
  return axios.request({
    method: 'get',
    url: '/user/pay/wallet/' + id
  })
}

export const changeUserStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/user/status/' + id
  })
}

export const getUserPayList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/user/pay'
  })
}

export const getUserPayListColor = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/user/pay/coloration'
  })
}

export const getUserPayUnlockList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/user/play/unlock'
  })
}

export const logout = (token) => {
  return axios.request({
    url: '/usercenter/sso/logout',
    method: 'post'
  })
}

export const getUserList = (data) => {
  return axios.request({
    url: '/user/coloration',
    method: 'post',
    data
  })
}

export const exportUserList = (data) => {
  return axios.request({
    url: '/user/coloration/export',
    method: 'post',
    data
  })
}

export const getUserMenuTree = (params) => {
  return axios.request({
    url: '/usercenter/user/tree',
    method: 'get',
    params: {
      applicationId: 1
    }
  })
}


export const editPsd = (data) => {
  return axios.request({
    url: '/user/modify/password',
    method: 'put',
    data
  })
}

export const getInfo = () => {
  return axios.request({
    url: '/usercenter/user/self/info',
    method: 'get',
  });
}
